"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Mail } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "How secure is the transition from human support to AI agents?",
  answer: "Our transition process utilizes encrypted data architectures and private LLM instances. We ensure that your proprietary support data remains isolated and secure throughout the entire integration phase."
}, {
  question: "Can AI agents handle complex, multi-step technical troubleshooting?",
  answer: "Absolutely. Our agents are built on advanced procedural logic frameworks, allowing them to diagnose intricate system failures and execute multi-stage solutions with higher precision than traditional human tiers."
}, {
  question: "What are the primary cost advantages of AI Tech Solutions?",
  answer: "By automating Tier 1 and Tier 2 support, businesses typically see a 70-85% reduction in operational overhead while simultaneously increasing ticket resolution speed and 24/7 availability."
}, {
  question: "How do the agents stay updated with our evolving software stack?",
  answer: "We implement continuous learning loops. As your documentation and software versions update, our agents ingest the new data in real-time, ensuring they are always equipped with the latest technical knowledge."
}];
export default function CommonInquiries() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="221773" id="common-inquiries" className="bg-background text-foreground py-16 md:py-24 overflow-hidden">
      <div ref={ref} className={`container max-w-3xl mx-auto px-4 md:px-6 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-bold font-default text-foreground mb-4 tracking-tight">
            Common Inquiries
          </h2>
          <p className="text-muted-foreground text-lg font-sans">
            Technical insights into the future of autonomous IT support.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full mb-12">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-b border-border/10 bg-secondary/30 mb-4 rounded-lg overflow-hidden transition-all duration-300 hover:border-primary/50 group data-[state=open]:border-primary data-[state=open]:shadow-[0_0_15px_rgba(0,255,242,0.2)]">
              <AccordionTrigger className="px-6 text-base md:text-lg font-bold font-default text-foreground hover:text-primary transition-colors text-left">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="px-6 pb-6 text-muted-foreground text-base leading-relaxed font-sans">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>

        <div className="flex flex-col items-center justify-center p-8 bg-secondary/50 backdrop-blur-md rounded-2xl text-center border border-primary/10 shadow-lg">
          <h3 className="text-xl font-bold font-default text-foreground mb-2">
            Still have questions?
          </h3>
          <p className="text-muted-foreground mb-6 max-w-md font-sans">
            If you require a deeper technical deep-dive, our engineering team is available to discuss your specific infrastructure needs.
          </p>
          <Button asChild size="lg" className="rounded-lg px-8 bg-primary text-primary-foreground hover:shadow-[0_0_20px_rgba(0,255,242,0.4)] transition-all duration-300">
            <Link to="/SupportHubPage">
              <Mail className="mr-2 size-4" />
              Contact Support
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}